module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "border": "1px solid #efefef",
      "border-radius": "6px",
      "padding": "20px 30px",
      "margin": "20px 0"
    }
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('el-button-group', [_c('router-link', {
    staticClass: "el-button el-button--default el-button--small",
    attrs: {
      "to": {
        name: 'FormFieldsEdit',
        params: {
          id: _vm.form._id
        }
      }
    }
  }, [_vm._v("\n      Edit fields\n    ")]), _vm._v(" "), _c('router-link', {
    staticClass: "el-button el-button--default el-button--small",
    attrs: {
      "to": {
        name: 'FormPreview',
        params: {
          id: _vm.form._id
        }
      },
      "title": "Preview form"
    }
  }, [_c('span', {
    staticClass: "el-icon-view"
  })]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "default",
      "size": "small",
      "title": "Edit form settings"
    },
    on: {
      "click": _vm.showFormSettings
    }
  }, [_c('span', {
    staticClass: "el-icon-setting"
  })]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "default",
      "size": "small",
      "title": "Export submissions as CVS"
    },
    on: {
      "click": _vm.exportForm
    }
  }, [_c('span', {
    staticClass: "el-icon-download"
  })])], 1)], 1), _vm._v(" "), _c('form-icon', {
    attrs: {
      "form": _vm.form
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-title"
  }, [_vm._v(_vm._s(_vm.form.title))]), _vm._v(" "), _c('div', {
    staticClass: "form-description"
  }, [_vm._v(_vm._s(_vm.form.description))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Form settings",
      "visible": _vm.showCreateForm
    },
    on: {
      "update:visible": function($event) {
        _vm.showCreateForm = $event
      }
    }
  }, [_c('settings-dialog', {
    attrs: {
      "item": _vm.form
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e10dab3c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/Forms/Info.vue
// module id = 363
// module chunks = 4